import type { TOC } from '@ember/component/template-only'
import type RexDashboardStudentIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import RouteTemplate from 'ember-route-template'
import { ReadingEggspressDashboardStudentPage } from 'teacher-ui-client/components/page/reporting/reading-eggspress/dashboard/student'

interface Signature {
  Args: { model: ModelFor<RexDashboardStudentIndexRoute> }
}

export const DashboardStudentIndexPage: TOC<Signature> = <template>
  <ReadingEggspressDashboardStudentPage
    @period={{@model.period}}
    @student={{@model.student}}
    @fetchComprehensionProgressOverviewReportTask={{@model.fetchComprehensionProgressOverviewReportTask}}
    @fetchComprehensionProgressEventsReportTask={{@model.fetchComprehensionProgressEventsReportTask}}
    @fetchComprehensionProgressPlacementEventsReportTask={{@model.fetchComprehensionProgressPlacementEventsReportTask}}
    @fetchLexileGrowthOverviewReportTask={{@model.fetchLexileGrowthOverviewReportTask}}
    @fetchProgressByCategoryOverviewReportTask={{@model.fetchProgressByCategoryOverviewReportTask}}
    @fetchAssessmentsOverviewReportTask={{@model.fetchAssessmentsOverviewReportTask}}
    @fetchAssessmentsEventsReportTask={{@model.fetchAssessmentsEventsReportTask}}
    @fetchAssignmentsOverviewReportTask={{@model.fetchAssignmentsOverviewReportTask}}
    @fetchAssignmentsEventsReportTask={{@model.fetchAssignmentsEventsReportTask}}
    @fetchSpellingProgressOverviewReportTask={{@model.fetchSpellingProgressOverviewReportTask}}
    @fetchSpellingProgressEventsReportTask={{@model.fetchSpellingProgressEventsReportTask}}
    @fetchAwardsOverviewReportTask={{@model.fetchAwardsOverviewReportTask}}
    @fetchStadiumOverviewReportTask={{@model.fetchStadiumOverviewReportTask}}
    @fetchBooksReadOverviewReportTask={{@model.fetchBooksReadOverviewReportTask}}
    @fetchBooksReadEventsReportTask={{@model.fetchBooksReadEventsReportTask}}
  />
</template>

export default RouteTemplate(DashboardStudentIndexPage)
